import React from "react";

const Subtitle: React.FC = () => {
    return (
        <>
            <p>
                Explore the competitive landscape around your chosen location.
                Identify hotspots of retail activity and assess your store's ability to stand out,
                helping shape a smarter market positioning strategy.
            </p>
        </>
    );
};

export default Subtitle;
